/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactElement, useState, useCallback, useEffect, useMemo } from 'react';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, GoBackButton, InputSearch, Table } from '~/components';
import { Switch } from '~/components';
import CollaboratorModal from '~/components/CollaboratorModal';
import { ISearch } from '~/components/Pagination/Search';
import { useAuth } from '~/hooks/auth.context';
import { useLoading } from '~/hooks/loading';
import { ICollaborator } from '~/models/Collaborator';
import { PageOptionsRequest } from '~/models/Common';
import { CollaboratorsService } from '~/services';

import * as S from './styles';

function Collaborators(): ReactElement {
  const { setLoading } = useLoading();

  const [collaborators, setColaborators] = useState<ICollaborator[]>([]);
  const [searchFilter, setSearchFilter] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [collaboratorId, setCollaboratorId] = useState<number>(-1);
  const [userCollaboratorId, setUserCollaboratorId] = useState<number>(-1);
  const [pageOptions, setPageOptions] = useState<PageOptionsRequest>({
    page: 1,
  });
  const { user } = useAuth();

  const handleGetCollaborators = async () => {
    try {
      setLoading(true);

      const response = await CollaboratorsService.getCollaborators();
      const formatResponse = response.data.filter(
        (item) =>
          item.user.email.toLowerCase().includes(searchFilter.toLowerCase()) ||
          item.user.name.toLowerCase().includes(searchFilter.toLowerCase()),
      );
      setColaborators(searchFilter === '' ? response.data : formatResponse);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao requisitar dados do servidor!');
    }
  };

  const handleEditCollaborator = useCallback(
    (collaborator: ICollaborator) => {
      if (
        (user &&
          user.collaborator &&
          collaborator.id === user.collaborator.id) ||
        user?.role === 'admin'
      ) {
        setCollaboratorId(collaborator.id);
        setUserCollaboratorId(collaborator.user_id);
        setModalIsOpen(true);
      } else toast.error('Você  só  pode editar o seu perfil!');
    },
    [user],
  );

  const activeCollaborator = useCallback(
    async (id: number) => {
      try {
        setLoading(true);

        const { data } = await CollaboratorsService.getOnlyCollaborator(id);
        if (
          (user && user.collaborator && id === user.collaborator.id) ||
          user?.role === 'admin'
        ) {
          await CollaboratorsService.desactiveCollaborator(
            id,
            !data.collaborator.status,
            data.dec_password,
          );
        } else toast.error('Você  só  pode editar o seu perfil!');

        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error('Ocorreu um problema ao requisitar dados do servidor!');
      }
    },
    [user],
  );

  useEffect(() => {
    handleGetCollaborators();
    // searchFilter,
    // page: pageOptions.page,
    // perpage: 8,
  }, [searchFilter, pageOptions.page, modalIsOpen]);

  const CollaboratorsTableMemo = useMemo(
    () => (
      <Table colsNames={['Ativo', 'Nome', 'Email', '']}>
        {collaborators.map((collaborator) => (
          <tr
            key={collaborator.id}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          >
            <td>
              <Switch
                name="status"
                defaultChecked={!!collaborator.status}
                disabled={
                  collaborator.id === user?.collaborator?.id ||
                  user?.role !== 'admin'
                }
                onClick={() => activeCollaborator(collaborator.id)}
              />
            </td>
            <td
              onClick={() => {
                handleEditCollaborator(collaborator);
              }}
              style={{ paddingLeft: 0 }}
            >
              {collaborator.user.name}
            </td>
            <td
              onClick={() => {
                handleEditCollaborator(collaborator);
              }}
              style={{ paddingLeft: 0 }}
            >
              {collaborator.user.email}
            </td>
            <td
              onClick={() => {
                handleEditCollaborator(collaborator);
              }}
            >
              {'>'}
            </td>
          </tr>
        ))}
      </Table>
    ),
    [activeCollaborator, collaborators, handleEditCollaborator, user],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Listagem de Colaboradores</S.Title>
          <InputSearch
            name="search"
            onSearch={(value) => setSearchFilter(value)}
            placeholder="Buscar por nome ou email"
          />
        </S.Header>
        {CollaboratorsTableMemo}
        <S.Footer>
          <Button
            textContent="Cadastrar colaborador"
            onClick={() => {
              setCollaboratorId(-1);
              setModalIsOpen(true);
            }}
            size="small"
            variant="black"
            extraStyles={{
              maxWidth: 300,
            }}
          />
          {/* <Pagination
            pageCount={collaborators.lastPage!}
            pageRangeDisplayed={3}
            {...{ setPageOptions }}
          /> */}
        </S.Footer>
      </S.Container>
      <CollaboratorModal
        editForm={collaboratorId !== -1}
        collaboratorId={collaboratorId}
        userCollaboratorId={userCollaboratorId}
        modalIsVisible={modalIsOpen}
        setModalIsVisible={setModalIsOpen}
      />
    </>
  );
}

export default Collaborators;
